<mat-dialog-content class="mat-typography user_tts">
    <div class="container form_wrapper" [appDeviceClass]="'custom-scroll custom-scroll-t'">
        <div class="title_modal d-f-c">
            {{"Executor TTS settings" | translate}}            
        </div>

        <mat-nav-list *ngIf="ttsItems?.length">
            <mat-list-item *ngFor="let tts of ttsItems; let i = index;" class="data_out_item">
                <div class="data_item">
                    <div class="id mr-1">
                        ID: {{tts.id}}
                    </div>
                    <div class="data_item_info">
                        <ng-container *ngIf="tts.params.provider && tts.params.provider == 'openai'; else elseTemplateVOV">
                            {{"VO Engine" | translate}} 2
                        </ng-container>
                        <ng-template #elseTemplateVOV>
                            {{"VO Engine" | translate}} 1
                        </ng-template>
                    </div>
                    <button mat-icon-button style="color: rgb(136, 32, 32);" (click)="deleteTTS(tts.id, i)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button mat-icon-button style="color: rgb(18, 97, 16);" (click)="userTTS(tts)">
                        <mat-icon>edit</mat-icon>
                    </button>
                </div>
            </mat-list-item>
        </mat-nav-list>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <div class="f_w_p_btns d-f-c">
        <button mat-raised-button (click)="close()">
            {{ "Close" | translate }}
        </button>
        <button class="ml-1" mat-raised-button color="primary" (click)="userTTS()" *ngIf="!ttsItems?.length">
            {{ "Create" | translate }}
        </button>
    </div>
</mat-dialog-actions>